import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';

import MKSSpreadsheet from './SpreadsheetLayout/MKSSpreadsheet';
import RolesList from '../common/components/RolesList/RolesList';
import LockingsList from '../common/components/LockingsList/LockingsList';
import IterationsModal from './IterationsModal';
import Icon from '../common/components/Icon';
import { PrimaryButton, FloatingButton } from '../Ui';
import SelectionOverlay from './SelectionOverlay';
import { addItem, removeItem, toggleItem } from '../utils/immutability-helpers';

import buildTree from '../plan/lockings/tree';
import { getRolesSelector } from '../reducers/roles';
import {
	getLockings,
	getLockingsWithoutRootSelector
} from '../reducers/lockings';
import { doShowToast } from '../reducers/app/toast';
import * as API from '../webAPI/MKSService';

class PatternDuplicationRoute extends Component {
	state = {
		selectedLockings: [],
		selectedRoles: [],
		showModal: false
	};

	componentDidMount() {
		const { getRoles, getLockings } = this.props;
		getRoles();
		getLockings();
	}

	render() {
		const { roles, lockings } = this.props;
		const { showModal } = this.state;

		return (
			<div style={{ height: '100%' }}>
				<MKSSpreadsheet
					roles={roles}
					lockings={lockings}
					header={this.renderHeader()}
					columnsHeader={this.renderColumnsHeader()}
					rowsHeader={this.renderRowsHeader()}
					content={this.renderRightsOverlay()}
					floatingButton={
						<FloatingButton
							iconName="close"
							onClick={this.cancelDuplication}
						/>
					}
					buttons={this.renderButtons()}
				/>

				<IterationsModal
					isOpen={showModal}
					onSubmit={this.handleSubmit}
					requestCloseFn={this.closeModal}
				/>
			</div>
		);
	}

	renderHeader = () => (
		<div
			style={{ width: '300px', height: '70px' }}
			className="pattern-duplication__header"
		>
			Nouveau motif
		</div>
	);

	renderColumnsHeader = () => {
		const { roles } = this.props;
		return (
			<div>
				<RolesList roles={roles} onClick={this.toggleRole} />
				{this.renderRolesOverlay()}
			</div>
		);
	};

	renderRowsHeader = () => {
		const { lockingsTree } = this.props;
		return (
			<div>
				<LockingsList
					lockings={lockingsTree.children}
					onItemClick={this.toggleLocking}
				/>
				{this.renderLockingsOverlay()}
			</div>
		);
	};

	renderButtons = () => {
		const { selectedRoles, selectedLockings } = this.state;
		return (
			<div>
				<PrimaryButton
					iconName="check"
					raised
					onClick={this.handleClick}
				>
					Créer le motif
				</PrimaryButton>
			</div>
		);
	};

	toggleRole = role => {
		const { selectedRoles } = this.state;

		this.setState({ selectedRoles: toggleItem(selectedRoles, role) });
	};

	toggleLocking = (locking, parent) => {
		const { selectedLockings } = this.state;
		const entity = parent ? parent : locking;

		this.setState({
			selectedLockings: toggleItem(selectedLockings, entity)
		});
	};

	// TODO: rename
	handleClick = () => {
		const { showToast } = this.props;
		const { selectedRoles, selectedLockings } = this.state;

		const noRolesSelected = selectedRoles.length === 0;
		if (noRolesSelected) {
			showToast('error', 'Veuillez sélectionner au moins une clé');
		}

		const noLockingsSelected = selectedLockings.length === 0;
		if (noLockingsSelected) {
			showToast('error', 'Veuillez sélectionner au moins une ouverture');
		}

		const hasError = noRolesSelected || noLockingsSelected;

		if (hasError) return;

		this.setState({ showModal: true });
	};

	handleSubmit = iterations => {
		const { projectId } = this.props.params;
		const { selectedRoles, selectedLockings } = this.state;

		const rolesIds = selectedRoles.map(role => role.role_id);
		const lockingsIds = selectedLockings.map(locking => locking.locking_id);

		// HOTFIX
		// [] (4th parameter) instead of this.getLockingsToAddRights()
		API.duplicatePattern(
			projectId,
			rolesIds,
			lockingsIds,
			[],
			iterations
		).then(
			() => null,
			() =>
				browserHistory.push(
					`/app/project/${encodeURIComponent(projectId)}/plan`
				)
		);
	};

	getLockingsToAddRights = () => {
		const { selectedRoles } = this.state;

		// Return only the common rights (lockings id) between all selected roles
		const initialArray = selectedRoles[0].lockings.slice();

		const lockingsAddRight = selectedRoles.reduce(
			(commonLockings, role) => {
				return role.lockings.filter(
					lockingId => commonLockings.indexOf(lockingId) !== -1
				);
			},
			initialArray
		);

		return lockingsAddRight;
	};

	renderRolesOverlay = () => {
		const { roles } = this.props;
		const { selectedRoles } = this.state;

		const overlays = [];

		selectedRoles.forEach(role => {
			const index = roles.findIndex(
				role2 => role.role_id === role2.role_id
			);

			overlays.push(
				<SelectionOverlay
					key={role.role_id}
					left={`${index * 110}px`}
					width="110px"
					height="70px"
				/>
			);
		});

		return overlays;
	};

	renderLockingsOverlay = () => {
		const { lockings } = this.props;
		const { selectedLockings } = this.state;

		const overlays = [];

		selectedLockings.forEach(locking => {
			const index = lockings.findIndex(
				locking2 => locking.locking_id === locking2.locking_id
			);

			overlays.push(
				<SelectionOverlay
					key={locking.locking_id}
					top={`${index * 50}px`}
					width="300px"
					height={`${50 + locking.children.length * 50}px`}
				/>
			);
		});

		return overlays;
	};

	renderRightsOverlay = () => {
		const { roles, lockings } = this.props;
		const { selectedRoles } = this.state;

		const overlays = [];

		selectedRoles.forEach(role => {
			const index = roles.findIndex(
				role2 => role.role_id === role2.role_id
			);

			overlays.push(
				<SelectionOverlay
					key={role.role_id}
					top="70px"
					left={`${index * 110 + 300}px`}
					width="110px"
					height={`${lockings.length * 50}px`}
				/>
			);
		});

		return overlays;
	};

	closeModal = () => {
		this.setState({ showModal: false });
	};

	cancelDuplication = () => {
		const { projectId } = this.props.params;
		browserHistory.push(
			`/app/project/${encodeURIComponent(projectId)}/plan`
		);
	};
}

function mapStateToProps(state) {
	const lockings = getLockings(state);
	return {
		roles: getRolesSelector(state),
		lockings: getLockingsWithoutRootSelector(state).sort(
			(l1, l2) => l1.lft - l2.lft
		),
		lockingsTree: buildTree(getLockings(state))
	};
}

export default connect(mapStateToProps, mapDispatchToprops)(
	PatternDuplicationRoute
);

import { getRolesRequest } from '../plan/roles/rolesActions';
import { getLockingsRequest } from '../plan/lockings/lockingsActions';
import store from '../app/store';

function mapDispatchToprops(dispatch, ownProps) {
	const { projectId } = ownProps.params;
	return {
		getRoles: () => dispatch(getRolesRequest(projectId)),
		getLockings: () => dispatch(getLockingsRequest(projectId)),
		showToast: (type, text) => dispatch(doShowToast(type, text))
	};
}



// WEBPACK FOOTER //
// ./src/js/PatternDuplication/index.js